<template>
  <header class="" :class="className">
    <div class="pk-header-background pk-flex__h-center">
      <img :src="headerImg" style="height: 100%" />
    </div>
    <div class="pk-header-frontground pk-flex">
      <div class="pk-page-spacing-flex"></div>
      <div
        class="pk-header-logo pk-flex__1 pk-flex--between"
        style="align-items: center"
      >
        <router-link tagName="div" to="/">
          <img src="../assets/icons/elaterna_logo_web_beta.svg" />
        </router-link>
        <div
          v-show="className == 'timeline'"
          class="pk-flex"
          id="timelineline-navtoolbar"
          style="align-items: center"
        >
          <img
            v-for="(t, ti) of timelineToolBar"
            :key="ti"
            :src="$_getSvg(t.src)"
            :style="t.enable ? '' : 'display:none'"
            @click="$store.commit('timelineToolBarEvent', t.name)"
            :title="t.tooltip"
          />
        </div>
      </div>
      <!--<div class="pk-flex__1 pk-flex--column pk-header-title-container">
        <div class="pk-header-title pk-flex__vh-center pk-flex--column">
          <div>MAGIC LANTERN</div>
          <div>THE HISTORICAL ART OF PROJECTION</div>
        </div>
      </div>-->
      <div class="pk-page-spacing-flex"></div>
    </div>
  </header>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  data() {
    return {};
  },

  computed: {
    timelineToolBar() {
      return this.$store.state.timelineToolBar;
    },
    className() {
      const p = this.$route.path;
      if (p === "/timeline") {
        return "timeline";
      }

      return p === "/" || p === "/ea" ? "pk-header-home" : "";
    },
    headerImg() {
      const p = this.$route.path;
      if (p === "/timeline") {
        return this.$getIcon("elaterna-header-timeline_1920x120px.jpg");
      }
      return p === "/" || p === "/ea"
        ? this.$getIcon("elaterna-header_1920x120px.jpg")
        : this.$getIcon("elaterna-header_1920x60px.jpg");
    },
  },
});
</script>


<style lang="scss">
@import "../assets/scss/header.scss";

#timelineline-navtoolbar {
  img {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    margin-left: 5px;
    width: 25px;
    height: 25px;
  }
}
</style>